// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as DomEl$GameDataCore from "../DomEl.res.mjs";
import * as Theme$GameDataCore from "../Theme.res.mjs";

function mounted() {
  var self = this ;
  var toggle = function () {
    var next = Theme$GameDataCore.themeToString(Theme$GameDataCore.nextTheme(Caml_option.nullable_to_opt(getTheme())));
    setTheme(next);
  };
  var off = DomEl$GameDataCore.on(self.el, "click", (function (param) {
          toggle();
        }));
  self._themeOff = off;
  var theme = getTheme();
  if (theme == null) {
    setTheme(Theme$GameDataCore.defaultTheme);
  } else {
    setTheme(theme);
  }
}

function updated() {
  var theme = getTheme();
  if (theme == null) {
    setTheme(Theme$GameDataCore.defaultTheme);
  } else {
    setTheme(theme);
  }
}

function destroyed() {
  var self = this ;
  var off = self._themeOff;
  if (!(off == null)) {
    return off();
  }
  
}

var themeSwitcher = {
  mounted: mounted,
  updated: updated,
  destroyed: destroyed
};

export {
  mounted ,
  updated ,
  destroyed ,
  themeSwitcher ,
}
/* mounted Not a pure module */
